/**
 * ModalPrimaryButton
 *
 * Standardized primary button used across auth/onboarding modals.
 * Implements Figma design specs with consistent sizing, typography, and styling.
 */
"use client";

import { modalSpacing } from "@/styles/design-tokens";

interface ModalPrimaryButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  className?: string;
}

export function ModalPrimaryButton({
  children,
  onClick,
  type = "button",
  disabled = false,
  className = "",
}: ModalPrimaryButtonProps) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`flex w-full items-center justify-center border border-black bg-black transition-colors hover:bg-gray-900 disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
      style={{
        height: modalSpacing.buttonHeight,
      }}
    >
      <span className="text-button text-white">{children}</span>
    </button>
  );
}
